import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { CompanyManager, UpdateManagerRequest } from "../../managers.types";
import { COMPANY_MANAGERS_QUERY_KEY } from "../useGetManagers";
import { requestUpdateManager } from "./updateManager.request";

const useUpdateManager = (
  options?: MutationOptions<CompanyManager, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateManagerRequest) => requestUpdateManager(body),
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: [COMPANY_MANAGERS_QUERY_KEY]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useUpdateManager;
